import { StyleSheet } from 'react-native';
import { pixelDimensions } from '../../../config/utils';

const styles = StyleSheet.create({
  container: {},
  title: {
    fontFamily: 'MBold',
    fontSize: pixelDimensions(5),
    marginVertical: pixelDimensions(2),
    textAlign: 'center',
  },
});

export default styles;
